import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Toggle from 'react-toggle';
import API from '../../../utils/API';

import InputField from '../../../components/inputs/inputField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import ColumnFilterRow from '../../../components/dropdown/columnFilterRow';

const groupTypeOptions = [
	{ label: 'Standard', value: 'standard' },
	{ label: 'Dynamic', value: 'dynamic' }
];

class EventGroupInfo extends Component {
	constructor(props) {
		super(props);
		this.skipNextFilterSync = false;
		this.state = {
			defaultViewFilters: this.getDisplayFilterLayers(props.editedGroup.attendeeFilterLayers)
		};
	}

	getEmptyFilterLayer = () => ({
		column: '',
		condition: '',
		value: '',
		concatOperator: 'and',
	});

	componentDidUpdate(prevProps) {
		if (this.skipNextFilterSync) {
			this.skipNextFilterSync = false;
			return;
		}

		const prevFilters = JSON.stringify(this.getDisplayFilterLayers(prevProps.editedGroup.attendeeFilterLayers));
		const currentFilters = JSON.stringify(this.getDisplayFilterLayers(this.props.editedGroup.attendeeFilterLayers));

		if (
			prevProps.editedGroup !== this.props.editedGroup ||
			prevProps.editedGroup._id !== this.props.editedGroup._id ||
			prevProps.editedGroup.updatedAt !== this.props.editedGroup.updatedAt ||
			prevFilters !== currentFilters
		) {
			this.setState({
				defaultViewFilters: this.getDisplayFilterLayers(this.props.editedGroup.attendeeFilterLayers)
			});
		}
	}

	getDisplayFilterLayers = (layers) => {
		if (!Array.isArray(layers) || layers.length === 0) return [this.getEmptyFilterLayer()];
		return layers.map((layer) => ({
			column: layer?.column || '',
			condition: layer?.condition || '',
			value: layer?.value || '',
			concatOperator: layer?.concatOperator || 'and',
		}));
	};

	getValidFilterLayers = (layers) => {
		if (!Array.isArray(layers)) return [];
		return layers
			.filter((layer) => layer && layer.column && layer.condition)
			.map((layer) => ({
				column: layer.column,
				condition: layer.condition,
				value: layer.value,
				concatOperator: layer.concatOperator || 'and',
			}));
	};

	updateFilters = (filters) => {
		const { updateGroupInfo } = this.props;
		const normalizedFilters = filters.length > 0 ? filters : [this.getEmptyFilterLayer()];
		this.setState({ defaultViewFilters: normalizedFilters });
		this.skipNextFilterSync = true;
		updateGroupInfo('attendeeFilterLayers', this.getValidFilterLayers(normalizedFilters));
	};

	render() {
		const { editedGroup, updateGroupInfo, readOnly, requiredFields, columns } = this.props;
		const dynamicGroupEnabled = !!editedGroup.dynamicGroup;
		const { defaultViewFilters } = this.state;
		const dynamicGroupInfoText = 'Dynamic groups can automatically include attendees based on rules instead of manual assignment.';
		const filterColumns = columns || [
			{ label: 'First Name', key: 'firstName', value: 'firstName', type: 'string' },
			{ label: 'Last Name', key: 'lastName', value: 'lastName', type: 'string' },
			{ label: 'Email', key: 'email', value: 'email', type: 'string' }
		];

		return (
			<div className='sectionBlock'>
				<h2 className='blockHeader'>Basic Details</h2>
				<InputField
					label={'Name'}
					value={editedGroup.name}
					type="text"
					errorTrigger={requiredFields.name}
					required={true}
					onChange={(e) => updateGroupInfo('name', e.target.value)}
				/>
			
				{!editedGroup.dynamicGroup && <ToggleField
					checked={editedGroup.maxCapacityEnabled}
					label={'Enable Max Capacity'}
					icons={false}
					disabled={readOnly}
					onChange={() => updateGroupInfo('maxCapacityEnabled', !editedGroup.maxCapacityEnabled)}
				/>}

				{!editedGroup.dynamicGroup && editedGroup.maxCapacityEnabled && (
					<InputField
						label={'Max Capacity'}
						value={editedGroup.maxCapacity || ''}
						type="text"
						onChange={(e) => updateGroupInfo('maxCapacity', e.target.value)}
					/>
				)}

			{!editedGroup.dynamicGroup && editedGroup.maxCapacityEnabled && <ToggleField
				checked={editedGroup.waitlistEnabled}
				label={'Enable Waitlist'}
				icons={false}
				disabled={readOnly}
				onChange={() => updateGroupInfo('waitlistEnabled', !editedGroup.waitlistEnabled)}
			/>}

				<SelectField
					label={'Type'}
					value={groupTypeOptions.find((option) => option.value === (editedGroup.dynamicGroup ? 'dynamic' : 'standard'))}
					options={groupTypeOptions}
					disabled={readOnly}
					information={dynamicGroupInfoText}
					onChange={(option) => updateGroupInfo('dynamicGroup', option?.value === 'dynamic')}
				/>

				{dynamicGroupEnabled && (
				<div className="columnDropdown filterDropdown groupFilterDropdown groupInfoFilterDropdown">
					<h2 className='blockHeader'>Attendee Filters</h2>
						<div className="viewFilterActionBar">
							<div className="filterActionButtons flex-ac ml-a">
								<button className="seBlue mr-10" onClick={() => this.updateFilters([this.getEmptyFilterLayer()])}>
									Clear all
								</button>
							</div>
						</div>
						<div className="filterLayersContainer">
							{defaultViewFilters.map((filter, index) => (
								<ColumnFilterRow
									key={`groupInfoFilter${filter.column}${index}`}
									firstFilter={index === 0}
									columns={filterColumns}
									selectedColumn={filter.column}
									selectedCondition={filter.condition}
									filterValue={filter.value}
									selectedConcatOption={filter.concatOperator}
									filterCount={defaultViewFilters.length}
									updateFilter={(updatedFilter) => {
										const updatedFilters = [...defaultViewFilters];
										updatedFilters[index] = updatedFilter;
										this.updateFilters(updatedFilters);
									}}
									removeFilter={() => {
										const updatedFilters = [...defaultViewFilters];
										updatedFilters.splice(index, 1);
										this.updateFilters(updatedFilters.length > 0 ? updatedFilters : [this.getEmptyFilterLayer()]);
									}}
								/>
							))}
						</div>
						<button
							className="addFilterButton w-100"
							onClick={() => {
								const updatedFilters = [...defaultViewFilters];
								updatedFilters.push(this.getEmptyFilterLayer());
								this.updateFilters(updatedFilters);
							}}
						>
							<i className="las la-plus-circle mr-10" /> Add another filter layer
						</button>
					</div>
				)}
				
			</div>
		);
	}
}

export default EventGroupInfo;
